import { render, staticRenderFns } from "./proStatusUserGroup.vue?vue&type=template&id=15f79434&scoped=true&"
import script from "./proStatusUserGroup.vue?vue&type=script&lang=js&"
export * from "./proStatusUserGroup.vue?vue&type=script&lang=js&"
import style0 from "./proStatusUserGroup.vue?vue&type=style&index=0&id=15f79434&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f79434",
  null
  
)

export default component.exports